// Nigeria States and Local Government Areas
export const nigeriaStates = [
  { value: 'Lagos', label: 'Lagos' },
  { value: 'Abuja', label: 'FCT Abuja' },
  { value: 'Kano', label: 'Kano' },
  { value: 'Rivers', label: 'Rivers' },
  { value: 'Oyo', label: 'Oyo' },
  { value: 'Kaduna', label: 'Kaduna' },
  { value: 'Ogun', label: 'Ogun' },
  { value: 'Edo', label: 'Edo' },
  { value: 'Delta', label: 'Delta' },
  { value: 'Anambra', label: 'Anambra' },
  { value: 'Enugu', label: 'Enugu' },
  { value: 'Imo', label: 'Imo' },
  { value: 'Abia', label: 'Abia' },
  { value: 'Akwa Ibom', label: 'Akwa Ibom' },
  { value: 'Bauchi', label: 'Bauchi' },
  { value: 'Bayelsa', label: 'Bayelsa' },
  { value: 'Benue', label: 'Benue' },
  { value: 'Borno', label: 'Borno' },
  { value: 'Cross River', label: 'Cross River' },
  { value: 'Ebonyi', label: 'Ebonyi' },
  { value: 'Ekiti', label: 'Ekiti' },
  { value: 'Gombe', label: 'Gombe' },
  { value: 'Jigawa', label: 'Jigawa' },
  { value: 'Kebbi', label: 'Kebbi' },
  { value: 'Kogi', label: 'Kogi' },
  { value: 'Kwara', label: 'Kwara' },
  { value: 'Nasarawa', label: 'Nasarawa' },
  { value: 'Niger', label: 'Niger' },
  { value: 'Ondo', label: 'Ondo' },
  { value: 'Osun', label: 'Osun' },
  { value: 'Plateau', label: 'Plateau' },
  { value: 'Sokoto', label: 'Sokoto' },
  { value: 'Taraba', label: 'Taraba' },
  { value: 'Yobe', label: 'Yobe' },
  { value: 'Zamfara', label: 'Zamfara' },
];

export const nigeriaLGAs = {
  Lagos: [
    'Agege', 'Ajeromi-Ifelodun', 'Alimosho', 'Amuwo-Odofin', 'Apapa',
    'Badagry', 'Epe', 'Eti-Osa', 'Ibeju-Lekki', 'Ifako-Ijaiye',
    'Ikeja', 'Ikorodu', 'Kosofe', 'Lagos Island', 'Lagos Mainland',
    'Mushin', 'Ojo', 'Oshodi-Isolo', 'Shomolu', 'Surulere'
  ],
  Abuja: [
    'Abaji', 'Abuja Municipal', 'Bwari', 'Gwagwalada', 'Kuje', 'Kwali'
  ],
  Kano: [
    'Ajingi', 'Albasu', 'Bagwai', 'Bebeji', 'Bichi', 'Bunkure',
    'Dala', 'Dambatta', 'Dawakin Kudu', 'Dawakin Tofa', 'Doguwa',
    'Fagge', 'Gabasawa', 'Garko', 'Garun Mallam', 'Gaya', 'Gezawa',
    'Gwale', 'Gwarzo', 'Kabo', 'Kano Municipal', 'Karaye', 'Kibiya',
    'Kiru', 'Kumbotso', 'Kunchi', 'Kura', 'Madobi', 'Makoda',
    'Minjibir', 'Nasarawa', 'Rano', 'Rimin Gado', 'Rogo', 'Shanono',
    'Sumaila', 'Takai', 'Tarauni', 'Tofa', 'Tsanyawa', 'Tudun Wada',
    'Ungogo', 'Warawa', 'Wudil'
  ],
  Rivers: [
    'Abua/Odual', 'Ahoada East', 'Ahoada West', 'Akuku-Toru', 'Andoni',
    'Asari-Toru', 'Bonny', 'Degema', 'Eleme', 'Emohua', 'Etche',
    'Gokana', 'Ikwerre', 'Khana', 'Obio/Akpor', 'Ogba/Egbema/Ndoni',
    'Ogu/Bolo', 'Okrika', 'Omuma', 'Opobo/Nkoro', 'Oyigbo',
    'Port Harcourt', 'Tai'
  ],
  Oyo: [
    'Afijio', 'Akinyele', 'Atiba', 'Atisbo', 'Egbeda', 'Ibadan North',
    'Ibadan North-East', 'Ibadan North-West', 'Ibadan South-East',
    'Ibadan South-West', 'Ibarapa Central', 'Ibarapa East', 'Ibarapa North',
    'Ido', 'Irepo', 'Iseyin', 'Itesiwaju', 'Iwajowa', 'Kajola', 'Lagelu',
    'Ogbomosho North', 'Ogbomosho South', 'Ogo Oluwa', 'Olorunsogo',
    'Oluyole', 'Ona Ara', 'Orelope', 'Ori Ire', 'Oyo East', 'Oyo West',
    'Saki East', 'Saki West', 'Surulere'
  ],
  Ogun: [
    'Abeokuta North', 'Abeokuta South', 'Ado-Odo/Ota', 'Egbado North',
    'Egbado South', 'Ewekoro', 'Ifo', 'Ijebu East', 'Ijebu North',
    'Ijebu North East', 'Ijebu Ode', 'Ikenne', 'Imeko Afon', 'Ipokia',
    'Obafemi Owode', 'Odeda', 'Odogbolu', 'Ogun Waterside', 'Remo North',
    'Shagamu'
  ],
  // Add more states as needed
  Default: ['Select state first']
};
